import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUserData } from '../redux/slices/user';

AdminGuard.propTypes = {
  children: PropTypes.node,
};

export default function AdminGuard({ children }) {
  const { user } = useSelector(selectUserData);
  const isAdmin = user.is_account_owner;
  if (!isAdmin) {
    return <Navigate to={'/app/account/settings'} />;
  }

  return <>{children}</>;
}
